import { act } from "react";

const initialState = {
    masterSettingsList: [],
    masterStateList: [],
    otherMasterActivityLogsTypeList: [],
    masterActivityLogsTypeList: [],
    ulbMasterActivityLogsTypeList: [],
    masterDepartmentList: [],
    masterTeamList: [],
    masterCityStateWiseList: [],
    masterCityStateId: null,
    masterTalukaStateCityWiseList: [],
    masterVillageStateCityTalukaWiseList: [],
    masterCityStateWiseList1: [],
    masterCityStateWiseList2: [],
    masterFacilityList: [],
    masterSalutationList: [],
    masterPincodeDataList: [],
    masterPincodeAddressType: "",
    masterCityStateWiseListowner: [],
    masterUsertypeLists: [],
    masterUserLists: [],
    masterAllInsuranceList: [],
    masterInsuranceList: [],
    masterInsuranceManagerWiseList: [],
    masterClientManagerWiseList: [],
    masterAllClientManagerList: [],
    masterAllGroupList: [],
    masterAllGroupHeaderList: [],
    masterDesignationList: [],
    masterUserDesignationList: [],
    masterHospitalList: [],
    masterRadiologyPathologyList: [],
    masterRelationshipList: [],
    masterQualificationList: [],
    masterOccupationList: [],
    masterLocalityList: [],
    masterEducationalList: [],
    masterEducationTypeList: [],
    masterGradeOfEvidenceList: [],
    masterReasonForRejectionList: [],
    masterSourceOfEvidenceList: [],
    masterFraudTypeList: [],
    masterPolicySubReasonList: [],
    masterJobList: [],
    masterRoomCategoryList: [],
    masterIncomeDetailsList: [],
    masterInjuryTypeList: [],
    masterClaimTypeList: [],
    masterSubClaimTypeList: [],
    masterClaimTypeListByService: [],
    masterSubClaimTypeListByClaimType: [],
    masterSubClaimTypeListByClaimTypeMap: {},
    masterClaimTypeListByServiceWithClientCompany: [],
    masterSubClaimTypeListByClaimTypeWithClientCompany: [],
    masterCheckList: [],
    masterAllCityList: [],
    masterExemptedClientList: [],
    masterClientTypeList: [],
    masterServiceTypeList: [],
    masterAllTemplateList: [],
    masterCorporateList: [],
    masterDoctorList: [],
    masterDoctorListType: null,
    masterPharmacyList: [],
    masterAgentBrokerList: [],
    masterClientCompanyList: [],
    masterClientInsuranceCompanyList: [],
    masterAuthorityLetterTemplateKeywordList: [],
    masterFieldOfficerList: [],
    masterFieldOfficerClientCompanyId: null,
    masterReportMakerList: [],
    masterQcManagerList: [],
    masterQcManagerByDoctorTypeList: [],
    masterQcManagerClientCompanyId: null,
    masterTeamLeaderList: [],
    masterTeamLeaderClientCompanyId: null,
    masterCEOList: [],
    masterCeoClientCompanyId: null,
    masterTableList: [],
    masterTableColumnList: [],
    loadingMaster: false,
    errorsMaster: {},
    masterApprovalPendingIdList: [],
    masterApprovalPendingDataList: [],
    masterApproveRejectPendingSubmitStatus: [],
    masterAllUserList: [],
    masterAssociateAllocationManagerList: [],
    saveAuthorityLetterStatus: [],
    getAuthorityLetterTemplateStatus: [],
    getMasterKeywordsStatus: [],
}

const masterReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GET_MASTER_SETTINGS_PENDING":
        case "GET_MASTER_APPROVAL_PENDING_DATA_LIST_PENDING":
        case "GET_MASTER_APPROVAL_PENDING_LIST_PENDING":
        case "GET_MASTER_STATE_PENDING":
        case "GET_OTHER_MASTER_ACTIVITY_LOGS_TYPE_PENDING":
        case "GET_MASTER_ACTIVITY_LOGS_TYPE_PENDING":
        case "GET_ULB_MASTER_ACTIVITY_LOGS_TYPE_PENDING":
        case "GET_MASTER_CITY_STATE_WISE_PENDING":
        case "GET_MASTER_TALUKA_STATE_CITY_WISE_PENDING":
        case "GET_MASTER_VILLAGE_STATE_CITY_TALUKA_WISE_PENDING":
        case "GET_MASTER_CITY_STATES_WISE_PENDING":
        case "GET_MASTER_CITY_STATES_OWNER_WISE_PENDING":
        case "GET_MASTER_PINCODE_PENDING":
        case "GET_MASTER_USERTYPE_USER_WISE_PENDING":
        case "GET_MASTER_USER_USERTYPE_WISE_PENDING":
        case "GET_MASTER_INSURANCE_PENDING":
        case "GET_MASTER_ALL_INSURANCE_PENDING":
        case "GET_MASTER_INSURANCE_MANAGER_WISE_PENDING":
        case "GET_MASTER_CLIENT_MANAGER_WISE_PENDING":
        case "GET_MASTER_DESIGNATION_PENDING":
        case "GET_MASTER_ALL_DEPARTMENT_LIST_PENDING":
        case "GET_MASTER_ALL_TEAM_LIST_PENDING":
        case "GET_MASTER_USER_DESIGNATION_PENDING":
        case "GET_MASTER_HOSPITAL_PENDING":
        case "GET_MASTER_RADIOLOGY_PATHOLOGY_PENDING":
        case "GET_MASTER_RELATIONSHIP_PENDING":
        case "GET_MASTER_QUALIFICATION_PENDING":
        case "GET_MASTER_OCCUPATION_PENDING":
        case "GET_MASTER_LOCALITY_PENDING":
        case "GET_MASTER_SALUTATION_PENDING":
        case "GET_MASTER_EDUCATION_PENDING":
        case "GET_MASTER_EDUCATION_TYPE_PENDING":
        case "GET_MASTER_GRADE_OF_EVIDENCE_PENDING":
        case "GET_MASTER_REASON_FOR_REJECTION_PENDING":
        case "GET_MASTER_SOURCE_OF_EVIDENCE_PENDING":
        case "GET_MASTER_FRAUD_TYPE_PENDING":
        case "GET_MASTER_POLICY_SUB_REASON_PENDING":
        case "GET_MASTER_JOB_PENDING":
        case "GET_MASTER_ROOM_CATEGORY_PENDING":
        case "GET_MASTER_INCOME_PENDING":
        case "GET_MASTER_INJURY_TYPE_PENDING":
        case "GET_MASTER_CLAIM_TYPE_PENDING":
        case "GET_MASTER_SUB_CLAIM_TYPE_PENDING":
        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_PENDING":
        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_PENDING":
        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_WITH_CLIENT_COMPANY_PENDING":
        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_WITH_CLIENT_COMPANY_PENDING":
        case "GET_MASTER_CHECKLIST_PENDING":
        case "GET_MASTER_ALL_CITY_PENDING":
        case "GET_EXEMPTED_CLIENT_LIST_PENDING":
        case "GET_CLIENT_TYPE_LIST_PENDING":
        case "GET_SERVICE_TYPE_LIST_PENDING":
        case "GET_MASTER_ALL_TEMPLATE_LIST_PENDING":
        case "GET_MASTER_CITY_STATES_fIELDD_WISE_PENDING":
        case "GET_MASTER_CITY_STATES_VISIT_WISE_PENDING":
        case "GET_MASTER_PHARMACY_PENDING":
        case "GET_MASTER_CORPORATE_PENDING":
        case "GET_MASTER_DOCTOR_PENDING":
        case "GET_MASTER_AGENT_BROKER_PENDING":
        case "GET_MASTER_INSURANCE_COMPANY_PENDING":
        case "GET_MASTER_FACILITY_PENDING":
        case "GET_MASTER_AUTHORITY_LETTER_TEMPLATE_KEYWORD_PENDING":
        case "GET_MASTER_ALL_FO_LIST_PENDING":
        case "GET_MASTER_ALL_REPORT_MAKER_LIST_PENDING":
        case "GET_MASTER_ALL_QC_MANAGER_LIST_PENDING":
        case "GET_MASTER_QC_MANAGER_BY_DOCTOR_TYPE_LIST_PENDING":
        case "GET_MASTER_ALL_CEO_LIST_PENDING":
        case "GET_MASTER_ALL_TEAM_LEADER_LIST_PENDING":
        case "GET_MASTER_ALL_CLIENT_MANAGER_PENDING":
        case "GET_ALL_GROUP_LIST_PENDING":
        case "GET_ALL_GROUP_HEADER_LIST_PENDING":
        case "GET_MASTER_TABLE_LIST_PENDING":
        case "GET_MASTER_TABLE_COLUMN_LIST_PENDING":
        case "MASTER_APPROVE_REJECT_PENDING_DATA_SUBMIT_PENDING":
        case "MASTER_APPROVE_REJECT_ALL_PENDING_DATA_SUBMIT_PENDING":
        case "GET_ALL_USER_LIST_PENDING":
        case "GET_ASSOCIATE_ALLOCATION_MANAGER_LIST_PENDING":
        case "SAVE_AUTHORITY_LETTER_PENDING":
        case "GET_AUTHORITY_LETTER_TEMPLATE_PENDING":
        case "GET_MASTER_KEYWORDS_PENDING":
            return { ...state, loadingMaster: true };

        case "GET_MASTER_SETTINGS_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSettingsList: action.payload,
            };

        case "GET_MASTER_STATE_FULFILLED":

            return {
                ...state,
                loadingMaster: false,
                masterStateList: action.payload
            };

        case "GET_OTHER_MASTER_ACTIVITY_LOGS_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                otherMasterActivityLogsTypeList: action.payload
            };

        case "GET_MASTER_ACTIVITY_LOGS_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterActivityLogsTypeList: action.payload
            };

        case "GET_ULB_MASTER_ACTIVITY_LOGS_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                ulbMasterActivityLogsTypeList: action.payload
            };

        case "GET_MASTER_FACILITY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterFacilityList: action.payload
            };
            
        case "GET_MASTER_PINCODE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterPincodeDataList: action.payload,
                masterPincodeAddressType: action.addressType
            };

        case "GET_MASTER_ALL_DEPARTMENT_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterDepartmentList: action.payload
            };
        case "GET_MASTER_ALL_TEAM_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterTeamList: action.payload
            };

        case "GET_MASTER_CITY_STATE_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCityStateWiseList: action.payload,
                masterCityStateId: action.stateId ?? state.masterCityStateId,
            };

        case "GET_MASTER_TALUKA_STATE_CITY_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterTalukaStateCityWiseList: action.payload
            };

        case "GET_MASTER_VILLAGE_STATE_CITY_TALUKA_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterVillageStateCityTalukaWiseList: action.payload
            };

        case "GET_MASTER_CITY_STATES_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCityStateWiseList1: action.payload,
            };
        case "GET_MASTER_CITY_STATES_fIELDD_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCityStateWiseList2: action.payload
            };
        case "GET_MASTER_CITY_STATES_VISIT_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCityStateWiseList3: action.payload
            };
        case "GET_MASTER_CITY_STATES_OWNER_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCityStateWiseListowner: action.payload
            };


        case "GET_MASTER_USERTYPE_USER_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterUsertypeLists: action.payload
            };

        case "GET_MASTER_USER_USERTYPE_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterUserLists: action.payload
            };

        case "GET_MASTER_ALL_INSURANCE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllInsuranceList: action.payload
            };
        case "GET_MASTER_INSURANCE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterInsuranceList: action.payload
            };

        case "GET_MASTER_INSURANCE_COMPANY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClientInsuranceCompanyList: action.payload
            };

        case "GET_MASTER_INSURANCE_MANAGER_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterInsuranceManagerWiseList: action.payload
            };

        case "GET_ALL_GROUP_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllGroupList: action.payload
            };

        case "GET_ALL_GROUP_HEADER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllGroupHeaderList: action.payload
            };

        case "GET_MASTER_CLIENT_MANAGER_WISE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClientManagerWiseList: action.payload
            };

        case "GET_MASTER_ALL_CLIENT_MANAGER_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllClientManagerList: action.payload
            };

        case "GET_MASTER_DESIGNATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterDesignationList: action.payload
            };

            case "GET_MASTER_USER_DESIGNATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterUserDesignationList: action.payload
            };

        case "GET_MASTER_SALUTATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSalutationList: action.payload
            };

        case "GET_MASTER_HOSPITAL_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterHospitalList: action.payload
            };

        case "GET_MASTER_RADIOLOGY_PATHOLOGY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterRadiologyPathologyList: action.payload
            };

        case "GET_MASTER_RELATIONSHIP_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterRelationshipList: action.payload
            };

        case "GET_MASTER_QUALIFICATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterQualificationList: action.payload
            };

        case "GET_MASTER_OCCUPATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterOccupationList: action.payload
            };

        case "GET_MASTER_LOCALITY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterLocalityList: action.payload
            };

        case "GET_MASTER_EDUCATION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterEducationalList: action.payload
            };

        case "GET_MASTER_EDUCATION_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterEducationTypeList: action.payload
            };

        case "GET_MASTER_GRADE_OF_EVIDENCE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterGradeOfEvidenceList: action.payload
            };

        case "GET_MASTER_REASON_FOR_REJECTION_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterReasonForRejectionList: action.payload
            };

        case "GET_MASTER_SOURCE_OF_EVIDENCE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSourceOfEvidenceList: action.payload
            };

        case "GET_MASTER_FRAUD_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterFraudTypeList: action.payload
            };

        case "GET_MASTER_POLICY_SUB_REASON_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterPolicySubReasonList: action.payload
            };

        case "GET_MASTER_JOB_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterJobList: action.payload
            };

        case "GET_MASTER_ROOM_CATEGORY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterRoomCategoryList: action.payload
            };

        case "GET_MASTER_INCOME_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterIncomeDetailsList: action.payload
            };

        case "GET_MASTER_INJURY_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterInjuryTypeList: action.payload
            };

        case "GET_MASTER_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClaimTypeList: action.payload
            };

        case "GET_MASTER_SUB_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSubClaimTypeList: action.payload
            };

        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClaimTypeListByService: action.payload
            };

        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSubClaimTypeListByClaimType: action.payload,
                masterSubClaimTypeListByClaimTypeMap: {
                    ...state.masterSubClaimTypeListByClaimTypeMap,
                    [action.claimTypeId]: action.payload
                }
            };

        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_WITH_CLIENT_COMPANY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClaimTypeListByServiceWithClientCompany: action.payload
            };

        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_WITH_CLIENT_COMPANY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterSubClaimTypeListByClaimTypeWithClientCompany: action.payload
            };

        case "GET_MASTER_CHECKLIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCheckList: action.payload
            };

        case "GET_MASTER_ALL_CITY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllCityList: action.payload
            };

        case "GET_EXEMPTED_CLIENT_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterExemptedClientList: action.payload
            };

        case "GET_CLIENT_TYPE_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterClientTypeList: action.payload
            };

        case "GET_SERVICE_TYPE_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterServiceTypeList: action.payload
            };

        case "GET_MASTER_ALL_TEMPLATE_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllTemplateList: action.payload
            };
        case "GET_MASTER_CORPORATE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCorporateList: action.payload
            };
        case "GET_MASTER_DOCTOR_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterDoctorList: action.payload,
                masterDoctorListType: action.doctorType ?? null,
            };
        case "GET_MASTER_PHARMACY_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterPharmacyList: action.payload
            };

        case "GET_MASTER_AGENT_BROKER_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAgentBrokerList: action.payload
            };

        case "GET_MASTER_AUTHORITY_LETTER_TEMPLATE_KEYWORD_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAuthorityLetterTemplateKeywordList: action.payload,
            };

        case "GET_MASTER_ALL_FO_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterFieldOfficerList: action.payload,
                masterFieldOfficerClientCompanyId:
                  action.clientCompanyId ?? state.masterFieldOfficerClientCompanyId,
            };

        case "GET_MASTER_ALL_REPORT_MAKER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterReportMakerList: action.payload,
            };

        case "GET_MASTER_ALL_QC_MANAGER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterQcManagerList: action.payload,
                masterQcManagerClientCompanyId:
                  action.clientCompanyId ?? state.masterQcManagerClientCompanyId,
            };

        case "GET_MASTER_QC_MANAGER_BY_DOCTOR_TYPE_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterQcManagerByDoctorTypeList: action.payload,
            };

        case "GET_MASTER_ALL_CEO_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterCEOList: action.payload,
                masterCeoClientCompanyId:
                  action.clientCompanyId ?? state.masterCeoClientCompanyId,
            };

        case "GET_MASTER_ALL_TEAM_LEADER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterTeamLeaderList: action.payload,
                masterTeamLeaderClientCompanyId:
                  action.clientCompanyId ?? state.masterTeamLeaderClientCompanyId,
            };

        case "GET_MASTER_TABLE_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterTableList: action.payload,
            };

        case "GET_MASTER_TABLE_COLUMN_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterTableColumnList: action.payload,
            };

        case "GET_MASTER_APPROVAL_PENDING_ID_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterApprovalPendingIdList: action.payload,
            };
        case "GET_MASTER_APPROVAL_PENDING_DATA_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterApprovalPendingDataList: action.payload,
            };

        case "GET_ALL_USER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAllUserList: action.payload,
            };

        case "GET_ASSOCIATE_ALLOCATION_MANAGER_LIST_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterAssociateAllocationManagerList: action.payload,
            };

        case "RESET_MASTER_APPROVAL_PENDING_ID_LIST":
            return {
                ...state,
                loadingMaster: false,
                masterApprovalPendingIdList: [],
            };
        case "RESET_MASTER_APPROVAL_PENDING_DATA_LIST":
            return {
                ...state,
                loadingMaster: false,
                masterApprovalPendingDataList: [],
            };
        case "RESET_MASTER_STATUS":
            return {
                ...state,
                loadingMaster: false,
                errors: {}
            };

        case "SAVE_AUTHORITY_LETTER_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                saveAuthorityLetterStatus: action.payload,
            };

        case "GET_AUTHORITY_LETTER_TEMPLATE_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                getAuthorityLetterTemplateStatus: action.payload,
            };

        case "GET_MASTER_KEYWORDS_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                getMasterKeywordsStatus: action.payload,
            };

        case "MASTER_APPROVE_REJECT_PENDING_DATA_SUBMIT_FULFILLED":
        case "MASTER_APPROVE_REJECT_ALL_PENDING_DATA_SUBMIT_FULFILLED":
            return {
                ...state,
                loadingMaster: false,
                masterApproveRejectPendingSubmitStatus: action.payload,
            };
        case "RESET_MASTER_APPROVE_REJECT_PENDING_DATA_SUBMIT":
            return {
                ...state,
                loadingMaster: false,
                masterApproveRejectPendingSubmitStatus: [],
            };

        case "GET_MASTER_SETTINGS_REJECTED":
        case "GET_MASTER_STATE_REJECTED":
        case "GET_OTHER_MASTER_ACTIVITY_LOGS_TYPE_REJECTED":
        case "GET_MASTER_ACTIVITY_LOGS_TYPE_REJECTED":
        case "GET_ULB_MASTER_ACTIVITY_LOGS_TYPE_REJECTED":
        case "GET_MASTER_ALL_DEPARTMENT_LIST_REJECTED":
        case "GET_MASTER_ALL_TEAM_LIST_REJECTED":
        case "GET_MASTER_CITY_STATE_WISE_REJECTED":
        case "GET_MASTER_TALUKA_STATE_CITY_WISE_REJECTED":
        case "GET_MASTER_VILLAGE_STATE_CITY_TALUKA_WISE_REJECTED":
        case "GET_MASTER_CITY_STATES_WISE_REJECTED":
        case "GET_MASTER_CITY_STATES_fIELDD_WISE_REJECTED":
        case "GET_MASTER_CITY_STATES_VISIT_WISE_REJECTED":
        case "GET_MASTER_PINCODE_REJECTED": 
        case "GET_MASTER_CITY_STATES_OWNER_WISE_REJECTED":
        case "GET_MASTER_USERTYPE_USER_WISE_REJECTED":
        case "GET_MASTER_INSURANCE_REJECTED":
        case "GET_MASTER_ALL_INSURANCE_REJECTED":
        case "GET_ALL_GROUP_LIST_REJECTED":
        case "GET_ALL_GROUP_HEADER_LIST_REJECTED":
        case "GET_MASTER_QUALIFICATION_REJECTED":
        case "GET_MASTER_INSURANCE_MANAGER_WISE_REJECTED":
        case "GET_MASTER_CLIENT_MANAGER_WISE_REJECTED":
        case "GET_MASTER_DESIGNATION_REJECTED":
        case "GET_MASTER_USER_DESIGNATION_REJECTED":
        case "GET_MASTER_HOSPITAL_REJECTED":
        case "GET_MASTER_RADIOLOGY_PATHOLOGY_REJECTED":
        case "GET_MASTER_CLAIM_TYPE_REJECTED":
        case "GET_MASTER_SUB_CLAIM_TYPE_REJECTED":
        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_REJECTED":
        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_REJECTED":
        case "GET_MASTER_CLAIM_TYPE_BY_SERVICE_WITH_CLIENT_COMPANY_REJECTED":
        case "GET_MASTER_SUB_CLAIM_TYPE_BY_CLAIM_TYPE_WITH_CLIENT_COMPANY_REJECTED":
        case "GET_MASTER_CHECKLIST_REJECTED":
        case "GET_MASTER_ALL_CITY_REJECTED":
        case "GET_EXEMPTED_CLIENT_LIST_REJECTED":
        case "GET_CLIENT_TYPE_LIST_REJECTED":
        case "GET_SERVICE_TYPE_LIST_REJECTED":
        case "GET_MASTER_ALL_TEMPLATE_LIST_REJECTED":
        case "GET_MASTER_USER_USERTYPE_WISE_REJECTED":
        case "GET_MASTER_PHARMACY_REJECTED":
        case "GET_MASTER_AGENT_BROKER_REJECTED":
        case "GET_MASTER_INSURANCE_COMPANY_REJECTED":
        case "GET_MASTER_FACILITY_REJECTED":
        case "GET_MASTER_AUTHORITY_LETTER_TEMPLATE_KEYWORD_REJECTED":
        case "GET_MASTER_ALL_FO_LIST_REJECTED":
        case "GET_MASTER_ALL_REPORT_MAKER_LIST_REJECTED":
        case "GET_MASTER_ALL_QC_MANAGER_LIST_REJECTED":
        case "GET_MASTER_QC_MANAGER_BY_DOCTOR_TYPE_LIST_REJECTED":
        case "GET_MASTER_ALL_CEO_LIST_REJECTED":
        case "GET_MASTER_ALL_TEAM_LEADER_LIST_REJECTED":
        case "GET_MASTER_ALL_CLIENT_MANAGER_REJECTED":
        case "GET_MASTER_TABLE_LIST_REJECTED":
        case "GET_MASTER_TABLE_COLUMN_LIST_REJECTED":
        case "GET_MASTER_APPROVAL_PENDING_ID_LIST_REJECTED":
        case "GET_MASTER_APPROVAL_PENDING_DATA_LIST_REJECTED":
        case "MASTER_APPROVE_REJECT_PENDING_DATA_SUBMIT_REJECTED":
        case "MASTER_APPROVE_REJECT_ALL_PENDING_DATA_SUBMIT_REJECTED":
        case "GET_ALL_USER_LIST_REJECTED":
        case "GET_ASSOCIATE_ALLOCATION_MANAGER_LIST_REJECTED":
        case "SAVE_AUTHORITY_LETTER_REJECTED":
        case "GET_AUTHORITY_LETTER_TEMPLATE_REJECTED":
        case "GET_MASTER_KEYWORDS_REJECTED":
        case "GET_MASTER_SALUTATION_REJECTED":
        case "GET_MASTER_GRADE_OF_EVIDENCE_REJECTED":
        case "GET_MASTER_REASON_FOR_REJECTION_REJECTED":
        case "GET_MASTER_SOURCE_OF_EVIDENCE_REJECTED":
        case "GET_MASTER_FRAUD_TYPE_REJECTED":
        case "GET_MASTER_POLICY_SUB_REASON_REJECTED":
        return {
                ...state,
                loadingMaster: false,
                errorsMaster: action.payload
            };

        default:
            return state;
    }
}

export default masterReducer;